import React, { FunctionComponent } from 'react';
import { makeStyles, createStyles, Dialog } from '@material-ui/core';

/* Modal Props */
type ModalProps = {
    open: boolean;
    maxWidth: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
    fullWidth: boolean;
    minHeight?: string;
    padding?: number | string;
    height?: string;
};

const Modal: FunctionComponent<ModalProps> = (props) => {
    /* Styles for modal */
    const useStyles = makeStyles(() =>
        createStyles({
            dialog: {
                minHeight: props.minHeight,
                height: props.height,
                padding: props.padding !== undefined ? props.padding : 10,
            },
        }),
    );
    const { open, maxWidth, fullWidth } = props;

    const classes = useStyles();

    return (
        <Dialog classes={{ paper: classes.dialog }} open={open} maxWidth={maxWidth} fullWidth={fullWidth}>
            {props.children}
        </Dialog>
    );
};

export default Modal;
